"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var assign_1 = __importDefault(require("core-js/library/fn/object/assign"));

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var UiContainer = function UiContainer(_a, _b) {
  var _c;

  var themeName = _a.themeName,
      children = _a.children,
      visible = _a.visible,
      innerRef = _a.innerRef;
  var theme = _b.theme;
  return withTheme_1["default"](theme, (_c = {}, _c[themeName] = true, _c[themeName + "--visible"] = Boolean(visible), _c))(React.createElement("div", {
    ref: innerRef
  }, children));
};

UiContainer.contextTypes = {
  theme: PropTypes.object
};
UiContainer.defaultProps = {
  visible: true
};
/**
 * Helper function to generate a UiContainer component type with a fixed
 * theme name.
 */

var containerFactory = function containerFactory(themeName) {
  return function (_a) {
    var innerRef = _a.innerRef,
        props = __rest(_a, ["innerRef"]);

    return React.createElement(UiContainer, __assign({
      themeName: themeName,
      innerRef: innerRef
    }, props));
  };
};
/**
 * Build UiContainer with sub containers
 */


var UiContainerWithRef = assign_1["default"](containerFactory('ui-container'), {
  Top: containerFactory('ui-container__top'),
  Bottom: containerFactory('ui-container__bottom'),
  Left: containerFactory('ui-container__left'),
  Right: containerFactory('ui-container__right')
});
exports["default"] = UiContainerWithRef;